import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isCollapse: false,
        menuList: [],
        userName: null,
        selectMenuList: [],
        selectUserList:[],
        
        
    },
    mutations: {
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        menuList(state,data){
            state.menuList = data
        },
        userInfo(state,data){
            state.userName = data
        },
        getMenyList(state, data){
            state.selectMenuList = data
        },
        setUserList(state, data){
            state.selectUserList = [];
            state.selectUserList = data;
        },
    },
    actions: {},
})
